var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_376_2447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7.72559L19.4121 8.31348C19.068 8.654 18.6167 8.86513 18.1348 8.91113C17.6527 8.95704 17.1689 8.83496 16.7666 8.56543L12.3164 13.0576V15.332C12.3163 16.9097 11.6697 18.4187 10.5273 19.5068L6.24805 15.2275C6.23583 15.2411 6.22497 15.2565 6.21191 15.2695L1.79102 19.6904C1.38116 20.1 0.717469 20.1 0.307617 19.6904C-0.102169 19.2805 -0.102264 18.6159 0.307617 18.2061L4.72754 13.7852C4.74057 13.7721 4.75503 13.7602 4.76855 13.748L0.450195 9.42969C1.56881 8.31176 3.08553 7.68372 4.66699 7.68359H6.94141L11.4346 3.2334C11.165 2.83108 11.043 2.34731 11.0889 1.86523C11.1348 1.38326 11.346 0.932033 11.6865 0.587891L12.3164 0L20 7.72559Z",
    fill: "#999999"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_376_2447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPin);
export default __webpack_public_path__ + "static/media/icon-pin.310c1cc49dfbfe985cb47f0e71428ae3.svg";
export { ForwardRef as ReactComponent };